import { inject, Injectable } from '@angular/core';
import { RelatedFilesApi } from '../apis/related-files.api';

@Injectable({
  providedIn: 'root',
})
export class SiaRelatedFilesService {
  #api = inject(RelatedFilesApi);

  async getRelatedInformations(id: string | undefined) {
    return await this.#api.getRelatedInformations(id);
  }

  async createDossier(name: string, sha256?: string[]) {
    return await this.#api.createDossier(name, sha256);
  }
  async deleteDossier(id: number | undefined) {
    return await this.#api.deleteDossier(id);
  }
  async removeFilesFromDossier(
    dossierID: number | undefined,
    sha256Array: string[],
  ) {
    return await this.#api.removeFilesFromDossier(dossierID, sha256Array);
  }
  async addFilesToDossier(id: number | undefined, sha256Array: string[]) {
    return await this.#api.addFilesToDossier(id, sha256Array);
  }
  async updateDossier(id: number | undefined, name: string | undefined) {
    return await this.#api.updateDossier(id, name);
  }
}
